import IconSetUpdaterDev from "./IconSetUpdaterDev";
import Page404 from "../Page404";
import {useCurrentUser} from "../../../customHooks/useContextCurrentUser";


export default function () {
    const currentUser = useCurrentUser();
    return [1, 2].includes(currentUser?.role) ? <IconSetUpdaterDev iconSetSection="parameters"/> : <Page404/>;
}
